var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTelegram = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_570_10782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8.15C0 5.20808 0 3.73713 0.599684 2.62572C1.06292 1.76719 1.76719 1.06292 2.62572 0.599684C3.73713 0 5.20808 0 8.15 0H15.85C18.7919 0 20.2629 0 21.3743 0.599684C22.2328 1.06292 22.9371 1.76719 23.4003 2.62572C24 3.73713 24 5.20808 24 8.15V15.85C24 18.7919 24 20.2629 23.4003 21.3743C22.9371 22.2328 22.2328 22.9371 21.3743 23.4003C20.2629 24 18.7919 24 15.85 24H8.15C5.20808 24 3.73713 24 2.62572 23.4003C1.76719 22.9371 1.06292 22.2328 0.599684 21.3743C0 20.2629 0 18.7919 0 15.85V8.15Z",
    fill: "#29AAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0C8.81812 0 5.76375 1.26506 3.51562 3.51469C1.2652 5.76522 0.000643966 8.81734 0 12C0 15.1813 1.26562 18.2357 3.51562 20.4853C5.76375 22.7349 8.81812 24 12 24C15.1819 24 18.2362 22.7349 20.4844 20.4853C22.7344 18.2357 24 15.1813 24 12C24 8.81869 22.7344 5.76431 20.4844 3.51469C18.2362 1.26506 15.1819 0 12 0Z",
    fill: "url(#paint0_linear_570_10782)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.43184 11.873C8.93059 10.349 11.2631 9.3443 12.4293 8.8588C15.7631 7.47261 16.455 7.23186 16.9068 7.2237C17.0062 7.22211 17.2275 7.24667 17.3718 7.36339C17.4918 7.46183 17.5256 7.59495 17.5425 7.68842C17.5575 7.7818 17.5781 7.99461 17.5612 8.16074C17.3812 10.0582 16.5993 14.6629 16.2018 16.7882C16.035 17.6874 15.7031 17.9889 15.3825 18.0184C14.685 18.0825 14.1562 17.5579 13.4812 17.1155C12.4256 16.4231 11.8293 15.9922 10.8037 15.3167C9.61872 14.5359 10.3875 14.1067 11.0625 13.4055C11.2387 13.2219 14.31 10.4291 14.3681 10.1758C14.3756 10.1441 14.3831 10.026 14.3118 9.96373C14.2425 9.9013 14.1393 9.92267 14.0643 9.93955C13.9575 9.96355 12.2718 11.0788 9.00184 13.2851C8.52372 13.614 8.09059 13.7743 7.70059 13.7659C7.27309 13.7567 6.44809 13.5236 5.83497 13.3245C5.08497 13.0802 4.48684 12.951 4.53934 12.536C4.56559 12.32 4.86372 12.099 5.43184 11.873Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_570_10782",
    x1: 1200,
    y1: 0,
    x2: 1200,
    y2: 2400,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_570_10782"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8.15C0 5.20808 0 3.73713 0.599684 2.62572C1.06292 1.76719 1.76719 1.06292 2.62572 0.599684C3.73713 0 5.20808 0 8.15 0H15.85C18.7919 0 20.2629 0 21.3743 0.599684C22.2328 1.06292 22.9371 1.76719 23.4003 2.62572C24 3.73713 24 5.20808 24 8.15V15.85C24 18.7919 24 20.2629 23.4003 21.3743C22.9371 22.2328 22.2328 22.9371 21.3743 23.4003C20.2629 24 18.7919 24 15.85 24H8.15C5.20808 24 3.73713 24 2.62572 23.4003C1.76719 22.9371 1.06292 22.2328 0.599684 21.3743C0 20.2629 0 18.7919 0 15.85V8.15Z",
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTelegram);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/telegram.d85bb59e9152c345d0ac530823803189.svg";